import React, {useEffect, useState} from 'react';
import {useRegistrationSteps} from "../utilities/context/registration-steps/registration-steps-context";
import useAuthCalls from "../utilities/custom-hooks/auth-calls";
import {doGetUserWithToken} from "../logic/users";
import Layout from "../components/Layout/Layout";
import Container from "../components/PurchaseForm/Container";
import Step1 from "../components/PurchaseSteps/Step1";
import Step2 from "../components/PurchaseSteps/Step2";
import Step3 from "../components/PurchaseSteps/Step3";
import Loading from "../components/UI/Loading";

const RegistrationAndPurchase = () => {

    const {step, setStep, loadUser, setRegistrationError, setEmailVerified} = useRegistrationSteps();
    const {call} = useAuthCalls();

    const [loading, setLoading] = useState(false);

    const handleStep = () => {
        switch (step) {
            case 1:
                return <Step1/>;
            case 2:
                return <Step2/>
            case 3:
                return <Step3/>
            default:
                return <div className="font-bold text-red-500">Error</div>
        }
    }

    useEffect(() => {
        const setup = async () => {
            setLoading(true);
            const urlParams = new URLSearchParams(window.location.search);
            let token = urlParams.get('token');

            if (token) {
                localStorage.setItem('registration_sent', "true");
                await call(() => doGetUserWithToken(token),
                    (res) => {
                        if (res && res.user) {
                            loadUser(res.user);
                            setEmailVerified(true);
                        }
                    },
                    (error) => {
                        console.log(error);
                        if (error) {
                            setEmailVerified(false);
                            setRegistrationError(error.message ?? "Errore di registrazione");
                            setStep(1);
                        }
                    }
                );
            }
            setLoading(false);
        }

        setup();
    }, []);

    return (
        <Layout>
            <div className="mt-16">
                <div className="text-normal md:text-2xl">Prova <b>GRATIS</b> per 15 giorni</div>
                <div className=" text-normal md:text-2xl mb-4">Registrati per iniziare ad utilizzare <span
                    className="font-bold">ediliziAPP</span></div>
            </div>

            <Container className="w-full md:w-3/4 m-4 mb-32 p-2 md:p-8" style={{maxWidth: "1200px"}}>
                {loading ?
                    <Loading label="Caricamento in corso" className="text-xl"/>
                    :
                    handleStep()
                }

            </Container>
        </Layout>
    );
};

export default RegistrationAndPurchase;